import React, { Component } from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export class RenderShift4Form extends Component {

    render() {
        const { paymentGateway, handleData, idx } = this.props;

        return (
            <div>
                <FormGroup row>
                    <Label sm={3}>
                        <FormattedMessage id="PaymentGateway.AccountId" />
                    </Label>
                    <Col sm={9}>
                        <Input type="text" maxLength="50" name="userId" id="userId" value={paymentGateway.userId ? paymentGateway.userId : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={3}>
                        <FormattedMessage id="PaymentGateway.PublicKey" />
                    </Label>
                    <Col sm={9}>
                        <Input type="text" maxLength="100" name="publishableKey" id="publishableKey" value={paymentGateway.publishableKey ? paymentGateway.publishableKey : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={3}>
                        <FormattedMessage id="PaymentGateway.PrivateKey" />
                    </Label>
                    <Col sm={9}>
                        <Input type="text" maxLength="100" name="accessToken" id="accessToken" value={paymentGateway.accessToken ? paymentGateway.accessToken : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
            </div>
        );
    }
}